import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { record_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";

export class AttributeDTO extends Record {
    constructor(Name, Value) {
        super();
        this.Name = Name;
        this.Value = Value;
    }
}

export function AttributeDTO$reflection() {
    return record_type("Containers.InvoiceeAttributes.Model.AttributeDTO", [], AttributeDTO, () => [["Name", string_type], ["Value", string_type]]);
}

